import { render, staticRenderFns } from "./DiseasesDetail.vue?vue&type=template&id=222d3f4c&scoped=true"
import script from "./DiseasesDetail.vue?vue&type=script&lang=ts"
export * from "./DiseasesDetail.vue?vue&type=script&lang=ts"
import style0 from "./DiseasesDetail.vue?vue&type=style&index=0&id=222d3f4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222d3f4c",
  null
  
)

export default component.exports